import script from "./AppCalendar.vue?vue&type=script&setup=true&lang=js"
export * from "./AppCalendar.vue?vue&type=script&setup=true&lang=js"

import "./AppCalendar.vue?vue&type=style&index=0&id=cca3d7d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cca3d7d4"]])

export default __exports__